// @flow
import createBreakpoints from '@material-ui/core/styles/createBreakpoints'
import { createMuiTheme } from '@material-ui/core/styles'

const breakpoints = createBreakpoints({})

const theme: any = createMuiTheme({
  palette: {
    primary: {
      main: '#14908f',
    },
    secondary: {
      main: '#fd744d',
    },
  },
  hintLabel: {
    margin: '5px 15px',
    fontSize: '14px',
    color: '#757575',
    lineHeight: '16px',
  },
  rightAlignItem: {
    alignItems: 'center',
    justifyContent: 'flex-end',
  },
  typography: {
    fontSize: 16,
    default: {
      fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
      fontStyle: 'normal',
      fontWeight: 400,
      fontSize: '16px',
      lineHeight: '26px',
      color: '#333333',
    },
    body1: {
      fontSize: 16,
    },
    body2: {
      fontSize: 16,
      fontWeight: 'inherit',
    },
    h4: {
      fontWeight: 'inherit',
    },
    h3: {
      [breakpoints.down('xs')]: {
        fontWeight: '500',
        fontSize: '22px',
        fontFamily: '"Roboto", "Helvetica", "Arial", "sans-serif"',
        lineHeight: '34px',
        letterSpacing: '0em',
      },
    },
  },
  overrides: {
    MuiFormControlLabel: {
      root: {
        fontSize: 16,
        color: '#757575',
        fontWeight: 400,
      },
    },
    MuiButton: {
      root: {
        fontSize: 16,
        padding: '15px 40px',
        borderRadius: '8px',
      },
      text: {
        padding: '20px 40px',
      },
    },
    MuiCheckbox: {
      colorSecondary: {
        '&$checked': {
          color: '#14908f',
        },
      },
    },
    MuiRadio: {
      colorSecondary: {
        '&$checked': {
          color: '#14908f',
        },
      },
    },
    MuiFormHelperText: {
      root: {
        fontSize: '1em',
      },
    },
    MuiInput: {
      input: {
        '&::placeholder': {
          color: 'gray',
        },
      },
    },
    MuiStepIcon: {
      text: {
        fontWeight: 500,
      },
    },
    MuiStepLabel: {
      label: {
        fontSize: '0.9em',
      },
    },
    MuiSvgIcon: {
      root: {
        fontSize: '2rem',
        width: '1.5em',
        height: '1.5em',
      },
    },
    MuiAlert: {
      filledSuccess: {
        backgroundColor: '#D9EDF7',
        color: '#31708F',
      },
    },
  },
})

theme.props = {
  MuiButton: {
    disableElevation: true,
  },
}

export default theme
